<template>
	<div class="mainContentBackground villageBackground unselectable">
		<div class="sea viewBackground" :style="{top: '0px', left: villageBackgroundLeft, right: 'auto', height: '1440px', transform: 'perspective(1000px) scale3d(1, 1, 1)', transformOrigin: '50% 50%', filter: 'blur(0px)', perspective: '1000px'}">
			<div class="modalWrapper productionOverview" style="opacity: 1; top: 400px; align-items: flex-start; justify-content: center; display: flex; width: 100%; height: 100%;">
				<div class="modal productionOverview">
					<div class="modalContent">
						<div class="modalDecoration"></div>
						<div class="functionPanel unselectable">
							<a class="closeWindow clickable" @click="$router.push('/township')">
								<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
									<i class="action_cancel_tiny_flat_black"></i>
								</div>
							</a>
						</div>
						<div>
							<div class="contentHeader unselectable">
								<h2 class="msAntiScroll drag" draggable="true">
									<span class="building"><span>Обзор производства</span></span>
								</h2>
							</div>
						</div>
						<div class="heightTransitionContent" :style="{maxHeight: maxHeightContent}">
							<div class="contentTabulation">
								<nav class="tabulation  maintab unselectable">
									<a class="tab clickable" :class="{active: tab == 'wood', inactive: tab != 'wood'}" @click="onToggleTab('wood')">
										<div class="content">
											<span>Древесина</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'clay', inactive: tab != 'clay'}" @click="onToggleTab('clay')">
										<div class="content">
											<span>Глина</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'rock', inactive: tab != 'rock'}" @click="onToggleTab('rock')">
										<div class="content">
											<span>Камень</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'iron', inactive: tab != 'iron'}" @click="onToggleTab('iron')">
										<div class="content">
											<span>Железо</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'crop', inactive: tab != 'crop'}" @click="onToggleTab('crop')">
										<div class="content">
											<span>Зерно</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'balance', inactive: tab != 'balance'}" @click="onToggleTab('balance')">
										<div class="content">
											<span>Баланс</span>
										</div>
									</a>
								</nav>
								<div class="tabulationContent scrollable">
									<div class="scrollContentOuterWrapper">
										<div class="scrollContent" style="overflow-y: auto;" :style="{maxHeight: maxHeightInnerContent}">
											<div class="scrollContentInnerWrapper" style="width: auto;">
												<div class="productionOverview">
													<div class="loadedTab currentTab" v-if="tab == 'wood'">
														<wood />
													</div>
													<div class="loadedTab currentTab" v-if="tab == 'clay'">
														<clay />
													</div>
													<div class="loadedTab currentTab" v-if="tab == 'rock'">
														<rock />
													</div>
													<div class="loadedTab currentTab" v-if="tab == 'iron'">
														<iron />
													</div>
													<div class="loadedTab currentTab" v-if="tab == 'crop'">
														<crop />
													</div>
													<div class="loadedTab currentTab" v-if="tab == 'balance'">
														<balance />
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="window-overlay"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Wood from '@/components/pages/productionOverview/Wood';
import Clay from '@/components/pages/productionOverview/Clay';
import Rock from '@/components/pages/productionOverview/Rock';
import Iron from '@/components/pages/productionOverview/Iron';
import Crop from '@/components/pages/productionOverview/Crop';
import Balance from '@/components/pages/productionOverview/Balance';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Обзор производства | IW'});
	},
	data: () => ({
		maxHeightContent: '550px',
		maxHeightInnerContent: '530px',
		cancelHover: false,
		
		tab: 'wood',
		
		villageBackgroundLeft: '0px',
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_20.ogg');
				audio.play();
			}
		},
		onModalClose(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_7.ogg');
				audio.play();
			}
		},
		onToggleTab(tab, push = true){
			this.tab = tab;
			if(push) this.$router.push({query: {tab}});
			
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_8.ogg');
				audio.play();
			}
		},
		
		onResize(){
			//let leftpos = (window.innerWidth / 2) - (1920 / 2) - 70;
			let leftpos = (window.innerWidth / 2) - (1920 / 2);
			//console.log(window.innerWidth, leftpos);
			this.villageBackgroundLeft = leftpos+'px';
			
			let maxHeightContent = window.innerHeight - 325;
			maxHeightContent = (maxHeightContent < 550 ? 550 : maxHeightContent);
			this.maxHeightContent = maxHeightContent + 'px';
			this.maxHeightInnerContent = (maxHeightContent - 57 > 0 ? maxHeightContent - 57 : 0) + 'px';
		},
	},
	mounted(){
		this.onModalOpen();
		
		window.addEventListener('resize', this.onResize);
		this.onResize();
		
		if(this.$route.query.tab) this.tab = this.$route.query.tab;
		else this.$router.push({query: {tab: this.tab}});
	},
	unmounted(){
		this.onModalClose();
		
		window.removeEventListener('resize', this.onResize); 
	},
	beforeRouteUpdate(to, from, next){
		if(!to.query.tab) this.$router.push({query: {tab: 'wood'}});
		else if(to.query.tab != this.tab) this.onToggleTab(to.query.tab, false);
		next();
	},
	created(){
		this.gameModel.buildingQueueShow = true;
	},
	components: {
		Wood,
		Clay,
		Rock,
		Iron,
		Crop,
		Balance,
	},
}
</script>